export * from './malihu-scrollbar.service';
export * from './malihu-scrollbar.directive';
export * from './malihu-scrollbar.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/ngx-malihu-scrollbar/dist/lib/index.js
// module id = ../../../../ngx-malihu-scrollbar/dist/lib/index.js
// module chunks = 4